export const MAX_TEMPLATE_TAGS = 3;

export const LanguageList = [
  { value: 'hi', label: 'Hindi' },
  { value: 'en', label: 'English' },
  { value: 'en_US', label: 'English (US)' },
  { value: 'en_GB', label: 'English (UK)' },
  { value: 'bn', label: 'Bengali' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mr', label: 'Marathi' },
  { value: 'pa', label: 'Punjabi' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
];

export const CategoryOptions = [
  { label: 'Marketing', value: 'MARKETING' },
  { label: 'Utility', value: 'UTILITY' },
  { label: 'Authentication', value: 'AUTHENTICATION' },
];

export const HeaderOptions = [
  { label: 'Text', value: 'TEXT' },
  { label: 'Image', value: 'IMAGE' },
  { label: 'Video', value: 'VIDEO' },
  { label: 'Document', value: 'DOCUMENT' },
];

export const StatusOptions = [
  { label: 'Approved', value: 'APPROVED' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Rejected', value: 'REJECTED' },
];

export const ArchiveViewOptions = [
  { label: 'Active', value: 'false' },
  { label: 'Archived', value: 'true' },
];

export const WHATSAPP_ALLOWED_MIME = {
  image: ['image/jpeg', 'image/png'],
  video: ['video/mp4', 'video/3gpp'],
  audio: ['audio/aac', 'audio/mp4', 'audio/mpeg', 'audio/amr', 'audio/ogg'],
  file: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/csv',
  ],
};

export const WHATSAPP_LIMITS = {
  image: 5 * 1024 * 1024,
  video: 16 * 1024 * 1024,
  audio: 16 * 1024 * 1024,
  file: 100 * 1024 * 1024,
};

export const BLOCKED_EXTENSIONS = new Set([
  '.exe', '.msi', '.cmd', '.bat', '.com', '.scr', '.dll',
  '.sh', '.bash', '.ksh', '.zsh', '.ps1', '.psm1',
  '.vbs', '.js', '.mjs', '.ts', '.tsx', '.jsx',
  '.py', '.pyc', '.pyo', '.rb', '.php', '.pl', '.jar',
  '.apk', '.ipa', '.reg', '.sql',
]);

/** Trust Signal template API: shortlink `1` = on, `0` = off */
export const ClickTrackingOptions = [
  { label: 'True', value: '1' },
  { label: 'False', value: '0' },
];

export const DEFAULT_TEMPLATE_FORM = {
  name: '',
  language: '',
  category: 'UTILITY',
  tag_ids: [],
  description: '',
  components: [{ type: 'BODY', text: '' }],
  param: [],
  shortlink: '1',
};

export const DEFAULT_TEMPLATE_BUTTONS = { callAction: [], quickReply: [] };

export const DEFAULT_TEMPLATE_FILTERS = {
  limit: 10,
  search: '',
  page: 0,
  sortOrder: 'desc',
  sortField: 'created_at',
  category: '',
  botNumber: '',
  organisation: '',
  status: '',
  language: '',
  archived: 'false',
  tag_id: '',
  organisationObj: null,
  botNumberObj: null,
  categoryObj: null,
  tagObj: null,
  statusObj: null,
  languageObj: null,
  archivedObj: { label: 'Active', value: 'false' },
  startDate: null,
  endDate: null,
};

export function calculatePercentageOfTotal(count, total) {
  if (count > 0 && total > 0) return `${count}(${((count / total) * 100).toFixed(2)})`;
  if (count) return count;
  return 0;
}

function toDisplayText(value) {
  if (value == null || value === '') return '';
  return String(value).trim();
}

export function formatTemplateRecipientContact(row) {
  const name = toDisplayText(row?.whatsapp_name);
  const phone = toDisplayText(row?.phone_number);
  if (name && phone) return `${name} (${phone})`;
  return name || phone || '—';
}
